import { render, staticRenderFns } from "./Vragenlijsten.vue?vue&type=template&id=7f604c92&"
import script from "./Vragenlijsten.vue?vue&type=script&lang=js&"
export * from "./Vragenlijsten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports